export default __webpack_public_path__ + "static/media/5MarutiSuzukiCiaz.60cb0e9c.jpg";